module.exports = __webpack_public_path__ + "img/1478153843.c3524832.jpg";